import { Duration } from 'luxon';

export interface TimeRangeDurationInfo {
  readonly crossesMidnight: boolean;
  readonly offsetChange: number;
}

/**
 * Data structure used by {@link TimeRangeComponent} to represent the current duration value, as well as the diff as
 * compared to the original duration value of the time inputs.
 */
export class TimeRangeDurationState {

  public readonly info: TimeRangeDurationInfo;

  /**
   *
   * @param current - The current duration value based on the current values of start and end inputs
   * @param original - The original duration based on the original values of the start and end inputs
   * @param diff - The difference between the current and original durations
   * @param crossesMidnight - Whether the time range crosses midnight (into the next day)
   * @param offsetChange - The change in time zone offset, if any (e.g. due to entering or leaving DST)
   */
  constructor(
    public readonly current: Duration,
    public readonly original: Duration,
    public readonly diff: Duration,
    crossesMidnight: boolean = false,
    offsetChange: number = 0,
  ) {
    this.current = current;
    this.original = original;
    this.diff = diff;

    if (crossesMidnight || offsetChange) {
      this.info = {
        crossesMidnight,
        offsetChange,
      }
    }
  }

}
